import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { _URL } from './utils/constant';
import { genHeader } from './utils/auth';
const codeDetail = {
  "20101": 'ผิดพลาดในการตรวจสอบรหัส'
}

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  code?: number;
  msg?: string;
  msgDetail?: string;
}

/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      console.log(33, res)
      const { data, code, msg, msgDetail } =
        res as unknown as ResponseStructure;
      if (code !== 20000 && code !== 20101) {
        const error: any = new Error(msg || msgDetail);
        error.name = 'BizError';
        error.info = { code, msgDetail, data };
        throw error; // 抛出自制的错误
      } else if (code === 20101) {
        const error: any = new Error(msg || "ผิดพลาดในการตรวจสอบรหัส");
        error.name = 'BizError';
        error.info = { code, msgDetail, data };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.name === 'BizError') {
        const errorInfo: ResponseStructure | undefined = error.info;
        if (errorInfo) {
          const { msgDetail, code } = errorInfo;
          console.log(60, msgDetail, code)
          switch (errorInfo.code) {
            case ErrorShowType.SILENT:
              // do nothing
              break;
            case ErrorShowType.WARN_MESSAGE:
              message.warning(msgDetail);
              break;
            case ErrorShowType.ERROR_MESSAGE:
              message.error(msgDetail);
              break;
            default:
              message.error(msgDetail);
          }
        }
      } else if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        message.error(`Response status:${error.response.status}`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        message.error('None response! Please retry.');
      } else {
        console.log(error);
        // 发送请求时出了点问题
        message.error('Request error, please retry.');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      const baseurl = _URL?.baseurl || '';
      // 拦截请求配置，进行个性化处理。
      const url = baseurl + config?.url
      // header add operatorId
      return { ...config, url, headers: { ...config.headers, ...genHeader() } };
    }
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;
      if (data?.code !== 20000 && data?.code !== 20101) {
        message.error(data?.msg || data?.msgDetail);
      } else if (data?.code === 20101) {
        message.error('ผิดพลาดในการตรวจสอบรหัส');  
      }
      return response;
    },
  ],
};
